module.exports = __webpack_public_path__ + "static/vina-6b8b5b3488d52fd8cbca9e6e7e9223f5.jpg";